import { ErrorCode } from '@fluenceur/types';
import { isAxiosError } from 'axios';

/**
 * The answers the API gives when a payout changed under the brand's feet: it
 * was closed, it was just paid, or its payment is still being processed. Each
 * has its own sentence under `errors.<code>`, and each means the row the brand
 * acted on is stale.
 */
const PAYOUT_BATCH_CONFLICT_CODES: ReadonlySet<string> = new Set([
  ErrorCode.E_PAYOUT_BATCH_NO_LONGER_PAYABLE,
  ErrorCode.E_PAYOUT_BATCH_ALREADY_PAID,
  ErrorCode.E_PAYOUT_BATCH_PAYMENT_IN_PROGRESS,
]);

export const isPayoutBatchConflict = (error: unknown): boolean => {
  if (!isAxiosError<{ code?: string }>(error)) return false;
  const code = error.response?.data?.code;
  return code !== undefined && PAYOUT_BATCH_CONFLICT_CODES.has(code);
};
